import {
  addClass,
  CollectionView,
  DataType,
  GroupDescription,
  isNumber,
  PropertyGroupDescription,
  SortDescription,
  toggleClass,
} from "@grapecity/wijmo";
import * as wjcCore from "@grapecity/wijmo";
import * as wjcGrid from "@grapecity/wijmo.grid";
import * as wjcInput from "@grapecity/wijmo.input";
import { FlexGrid } from "@grapecity/wijmo.react.grid";
import { FlexGridColumn } from "@grapecity/wijmo.react.grid";
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";
import _ from "lodash";
import "./AssignList.css";
import React from "react";
import { useEffect, useRef, useState } from "react";
import { CustomGridEditor } from "../../../../components/CustomGridEditor";
import {
  Assign,
  AssignGroupingKey,
  DefaultGroupingExpansionState,
  Employee,
  NenkiInfo,
} from "../../../../types/types";
import { findByItem, nameof, nvlNumber } from "../../../../util/util";
import { GridState } from "../../assign-page.store";

export let assignListGrid = {
  ref: {} as any,
  collapseAll: () => assignListGrid.ref.collapseGroupsToLevel(0),
  expandAll: () => assignListGrid.ref.collapseGroupsToLevel(999),
};

/**
 * Props
 */
export interface AssignListProps {
  nenkiInfo: NenkiInfo;
  assigns: Assign[];
  employees: Employee[];
  groupingKey: AssignGroupingKey;
  defaultGroupingExpansionState: DefaultGroupingExpansionState;
  selectedItem?: Assign;
  gridState?: GridState;
  edit: (assigns: Assign[]) => void;
  changeOrder: (order: number[]) => void;
  changeGridState: (gridState: GridState) => void;
  changeCurrentRow: (id?: number, rowIndex?: number) => any;
}

const getOrder = (cv: CollectionView) => cv.items.map((item) => item.id);

/**
 * アサインリスト
 *
 * TODO: JLは先頭にする？
 * TODO: アサイン列でDeleteキーが押されたときは代わりに0を入れる
 * TODO: フィルタONの状態でリロードすると選択セルが一度真上に動く
 * TODO: 削除→変更パネル→onReloadでグリッドが空なのに最後に選択したアサインがselectedItemに残る
 *   その状態で削除実行すると最後に選択したアサインが削除される
 *   if (props.assigns.length === 0)で回避しているがやめたい
 * TODO: 4月に1入力 -> 変更タブで空白セルコピペ -> 1マス上に移動 -> 全件タブにアスタリスク出る
 */
export const AssignList = React.memo<AssignListProps>(
  (props) => {
    console.log(props);
    const [employeeComboBoxInitialized, setEmployeeComboBoxInitialized] =
      useState(false);
    const gridRef: any = useRef(null);
    const filterRef: any = useRef(null);

    const employeeMap = new wjcGrid.DataMap(
      props.employees,
      nameof<Employee>("kojinCode"),
      nameof<Employee>("fullName")
    );

    // const formatGroupHeader = (sender: any, e: any) => {
    //   if (e.index < 0 && e.data instanceof wjcCore.CollectionViewGroup) {
    //     const groupName = `(${e.data.jobCode}) ${e.data.name}`;
    //     console.log("### formatGroupHeader2", groupName);
    //     e.item.innerHTML = `<span style="font-size: large"><i class="ms-Icon ms-Icon--Group" aria-hidden="true"/> ${groupName}</span>`;
    //   }
    // };

    // componentDidUpdate
    useEffect(() => {
      const grid = gridRef.current.control;
      const filter = filterRef.current.control;
      const cv = grid.collectionView;

      assignListGrid.ref = grid;

      console.log(props.defaultGroupingExpansionState);
      if (props.defaultGroupingExpansionState === "collapse") {
        assignListGrid.collapseAll();
      } else if (props.defaultGroupingExpansionState === "expand") {
        assignListGrid.expandAll();
      }

      if (
        !employeeComboBoxInitialized &&
        !(!props.employees || props.employees.length === 0)
      ) {
        const gdInitial = new GroupDescription();
        gdInitial.groupNameFromItem = (item: Employee) => item.groupName;
        const empCv = new CollectionView(props.employees, {
          groupDescriptions: [gdInitial],
          sortDescriptions: ["groupName", "username"],
          currentItem: null,
        });

        // const employeeCell = new CustomGridEditor(
        // tslint:disable-next-line:no-unused-expression
        new CustomGridEditor(grid, "inChargeKojinCode", wjcInput.ComboBox, {
          headerPath: "fullName",
          selectedValuePath: "inChargeKojinCode",
          displayMemberPath: "fullName",
          itemsSource: empCv,
          showGroups: true,
          isRequired: false,
          dropDownCssClass: "cb-flex",
          // formatItem: formatGroupHeader
        });
        //         const combo = employeeCell.control;
        //         if (combo instanceof wjcInput.ComboBox) {
        //           combo.listBox.formatItem.addHandler((s, e: any) => {
        //             console.log({ e });
        //             e.item.innerHTML = `
        // <table>
        //   <tbody>
        //     <tr>
        //       <td style="width: 30px;">${e.data.groupName}</td>
        //       <td style="width: 30px;">${e.data.position}</td>
        //       <td style="width: 100px;">${e.data.fullName}</td>
        //     </tr>
        //   </tbody>
        // </table>
        // `;
        //           });
        //         }

        setEmployeeComboBoxInitialized(true);
      }

      initializeEventHandler(props, cv, grid, filter);
      restoreGridState(props, cv, filter);

      if (!props.selectedItem) {
        // noinspection TypeScriptValidateJSTypes
        grid.scrollIntoView(0, 0);
        grid.select(cv.groupDescriptions.length, 0);
        cv.currentChanged.raise(cv);
      } else if (props.assigns.length === 0) {
        // noinspection TypeScriptValidateJSTypes
        grid.scrollIntoView(0, 0);
        grid.select(cv.groupDescriptions.length, 0);
        cv.currentChanged.raise(cv);
      }

      props.changeOrder(getOrder(cv));

      grid.rows
        .filter((v: any) => v.dataItem.status === "removed")
        .forEach((v: any) => {
          v.isReadOnly = true;
        });

      // レンダリング時に必ずグリッドにフォーカスを当てる
      // grid.focus();
    }, [employeeComboBoxInitialized, props]);

    return (
      <>
        <FlexGrid
          ref={gridRef}
          autoGenerateColumns={false}
          itemsSource={createCollectionView(props)}
          stickyHeaders={true}
          allowDelete={true}
          imeEnabled={true}
          selectionMode={wjcGrid.SelectionMode.CellRange}
          keyActionEnter={wjcGrid.KeyAction.None}
          alternatingRowStep={0}
          formatItem={formatItem}
          groupHeaderFormat={"<b>{value}</b>"}
        >
          <FlexGridFilter ref={filterRef} />
          {/*TODO: Development時は表示する*/}
          {/*<FlexGridColumn*/}
          {/*  header="ID"*/}
          {/*  binding="id"*/}
          {/*  width={70}*/}
          {/*  isReadOnly={true}*/}
          {/*/>*/}
          <FlexGridColumn
            header="更新日"
            binding="updatedAt"
            width={75}
            isReadOnly={true}
            dataType={DataType.Date}
            format={"MM/dd"}
          />
          <FlexGridColumn
            header="ステータス"
            binding="orderStatusName"
            width={100}
            isReadOnly={true}
          />
          {/* <FlexGridColumn
            header="ジョブ"
            binding="jobName"
            width={300}
            isReadOnly={true}
          /> */}
          {/* Wijmoのバグ？先頭 or 末尾にこの非表示列を配置すると、グループヘッダで左端にいったときに変な位置が選択される */}
          {/* <FlexGridColumn header="ジョブ" binding="jobName" visible={false} /> */}
          <FlexGridColumn
            header="Gr"
            binding="groupName"
            width={50}
            isReadOnly={true}
            visible={false}
          />
          <FlexGridColumn
            header="客先"
            binding="clientName"
            width={100}
            isReadOnly={true}
            visible={false}
          />
          <FlexGridColumn
            header="ジョブ"
            binding="jobName"
            width={250}
            isReadOnly={true}
            visible={props.groupingKey === "inChargeKojinCode"}
          />
          <FlexGridColumn header="工程" binding="process" width={100} />
          <FlexGridColumn header="スキル" binding="skill" width={100} />
          <FlexGridColumn
            header="担当"
            binding="inChargeKojinCode"
            width={110}
            dataMap={employeeMap}
            isRequired={false}
            visible={props.groupingKey === "jobCode"}
          />
          {props.nenkiInfo.months.map((month) => (
            <FlexGridColumn
              key={month.month}
              header={`${month.month}月`}
              binding={month.columnName}
              width={60}
              dataType={DataType.Number}
              format={"f2"}
              isRequired={false}
              aggregate="Sum"
            />
          ))}
          <FlexGridColumn
            header="合計"
            binding="kosu_summary"
            width={60}
            dataType={DataType.Number}
            format={"f2"}
            isReadOnly={true}
            aggregate="Sum"
          />
          <FlexGridColumn header="メモ" binding="memo" width={200} />
        </FlexGrid>
      </>
    );
  },
  (p, n) => {
    // 再レンダリングの判定をassignsだけにしておかないと、行移動するたびにselectedItemが変わって
    // 再レンダリングが走って動きがガタガタになる
    // 明示的にselectedItemを指定して特定の行を選択したいとき(※)はassignsにも変更が入っているので問題ない
    // ※行挿入、行削除
    return p.assigns === n.assigns && p.groupingKey === n.groupingKey;
    // return _.isEqual(p.assigns, n.assigns);
  }
);

/**
 * セルの表示をカスタマイズする
 * @param grid
 * @param e
 */
const formatItem = (grid: any, e: any) => {
  const cellType = e.panel.cellType;
  const row = grid.rows[e.row];
  const col = grid.columns[e.col];

  if (
    cellType === wjcGrid.CellType.Cell &&
    row instanceof wjcGrid.GroupRow &&
    row.index >= 0
  ) {
    const name = row.dataItem.name;
    const groupingBy = row.dataItem.groupDescription._bnd._path;

    if (col.index === 0) {
      if (!name) {
        const label = `（未割り当て）`;
        e.cell.innerHTML = `<button class="wj-btn wj-btn-glyph wj-elem-collapse" type="button" tabindex="-1" aria-label="グループを切り替える" aria-expanded="true"><span class="wj-glyph-down-right"/></button> <b>${label}</b>`;
      } else if (groupingBy === "inChargeKojinCode") {
        const label = row.dataItem.items[0].inChargeName;
        e.cell.innerHTML = `<button class="wj-btn wj-btn-glyph wj-elem-collapse" type="button" tabindex="-1" aria-label="グループを切り替える" aria-expanded="true"><span class="wj-glyph-down-right"/></button> <b>${label}</b>`;
      } else {
        const item = row.dataItem.items[0];
        const label = `${item.groupName + " / "}${
          item.clientName ? item.clientName + " / " : ""
        }${item.jobName}`;
        e.cell.innerHTML = `<button class="wj-btn wj-btn-glyph wj-elem-collapse" type="button" tabindex="-1" aria-label="グループを切り替える" aria-expanded="true"><span class="wj-glyph-down-right"/></button> <b>${label}</b>`;
      }
    } else {
      const binding = col.binding;
      if (name?.length === 4 && binding.startsWith("month_")) {
        const sum = e.cell.innerHTML;
        if (sum <= 0.75) {
          e.cell.innerHTML = `<span style="color: red; font-weight: bold">${sum}</span>`;
        }
      }
    }
  }

  if (e.panel === grid.rowHeaders && e.col === 0) {
    const item: Assign = row.dataItem;
    switch (item.status) {
      case "added":
        e.cell.innerHTML =
          '<i class="ms-Icon ms-Icon--Add" aria-hidden="true"/>';
        break;
      case "edited":
        e.cell.innerHTML =
          '<i class="ms-Icon ms-Icon--Asterisk" aria-hidden="true"/>';
        break;
      case "removed":
        e.cell.innerHTML =
          '<i class="ms-Icon ms-Icon--Remove" aria-hidden="true"/>';
        break;
      default:
        // e.cell.innerHTML = item.id ?? ""; // TODO: Development時は表示する
        e.cell.innerHTML = "";
    }
  }

  if (e.panel === grid.cells) {
    const binding = col.binding;
    const assign = row.dataItem;

    // アサイン量列の場合、値が0.00のセルについては何も表示しない
    if (binding.startsWith("month_")) {
      const amount = assign[binding];
      toggleClass(e.cell, "empty-assign", isNumber(amount) && amount <= 0);
    }

    // 合計列の場合
    if (binding === "kosu_summary") {
      // https://demo.grapecity.com/wijmo/demos/Grid/Aggregation/Customaggregation/react
      const group = row instanceof wjcGrid.GroupRow ? assign : undefined;
      const kosuSummary = group
        ? group.getAggregate("Sum", "month_1st") +
          group.getAggregate("Sum", "month_2nd") +
          group.getAggregate("Sum", "month_3rd") +
          group.getAggregate("Sum", "month_4th") +
          group.getAggregate("Sum", "month_5th") +
          group.getAggregate("Sum", "month_6th")
        : nvlNumber(assign.month_1st) +
          nvlNumber(assign.month_2nd) +
          nvlNumber(assign.month_3rd) +
          nvlNumber(assign.month_4th) +
          nvlNumber(assign.month_5th) +
          nvlNumber(assign.month_6th);
      e.cell.textContent = wjcCore.Globalize.format(kosuSummary, col.format);
    }

    if (assign.status === "removed") {
      addClass(e.cell, "readonly-row");
    }
  }
};

/**
 * コレクションビューを作成する
 * @param props
 */
const createCollectionView = (props: AssignListProps) => {
  // Deep Cloneしないと、セル編集した時点でStateが書き換えられてしまう
  const source = _.cloneDeep(props.assigns);
  const cv = new CollectionView(source, {
    trackChanges: true,
  });

  if (props.selectedItem) {
    cv.moveCurrentTo(findByItem(source, props.selectedItem));
  }

  cv.deferUpdate(() => {
    if (props.gridState) {
      // Stateに保存されている状態を元にグリッドの状態を復元
      // ソート
      cv.sortDescriptions.clear();
      props.gridState.sortings.forEach((sorting: any) => {
        cv.sortDescriptions.push(
          new SortDescription(sorting.property, sorting.ascending)
        );
      });
      // グルーピング
      cv.groupDescriptions.clear();
      props.gridState.groupings.forEach((grouping: any) => {
        cv.groupDescriptions.push(
          new PropertyGroupDescription(grouping.propertyName)
        );
      });
    } else {
      // Stateに状態が保存されていない場合はデフォルト値を設定
      // グルーピング
      cv.groupDescriptions.clear();
      const key = new PropertyGroupDescription(props.groupingKey);
      cv.groupDescriptions.push(key);
    }
  });

  return cv;
};

/**
 * 現在のグリッドの状態をStateに保存する
 * @param props
 * @param grid
 * @param filter
 */
const saveGridState = (props: AssignListProps, grid: any, filter: any) => {
  // noinspection TypeScriptValidateJSTypes
  const gridState: GridState = {
    columns: grid.columnLayout,
    filters: filter.filterDefinition,
    sortings: grid.collectionView.sortDescriptions.map(
      (sortDesc: SortDescription) => ({
        property: sortDesc.property,
        ascending: sortDesc.ascending,
      })
    ),
    groupings: grid.collectionView.groupDescriptions.map(
      (groupDesc: PropertyGroupDescription) => ({
        propertyName: groupDesc.propertyName,
      })
    ),
  };
  props.changeGridState(gridState);
};

/**
 * イベントハンドラを初期化する
 * @param props
 * @param cv
 * @param grid
 * @param filter
 */
const initializeEventHandler = (
  props: AssignListProps,
  cv: CollectionView,
  grid: any,
  filter: any
) => {
  // 各種イベントハンドラを登録
  // CollectionViewは毎回newしているのでイベントハンドラの削除は不要
  // 列幅変更
  const onResizedColumn = function () {
    console.log("onResizedColumn");
    grid.resizedColumn.removeHandler(onResizedColumn);
    saveGridState(props, grid, filter);
  };
  grid.resizedColumn.removeAllHandlers();
  grid.resizedColumn.addHandler(onResizedColumn);

  // 列順変更
  const onDraggedColumn = () => {
    console.log("onDraggedColumn");
    grid.draggedColumn.removeHandler(onDraggedColumn);
    saveGridState(props, grid, filter);
  };
  grid.draggedColumn.removeAllHandlers();
  grid.draggedColumn.addHandler(onDraggedColumn);

  // ペースト
  // 複数行ペースト時にrowEditEndedが走らなくなったのでペーストイベントを拾って手動で発火させる
  const onPasted = () => {
    console.log("onPasted");
    grid.onRowEditEnded(grid);
  };
  grid.pasted.removeAllHandlers();
  grid.pasted.addHandler(onPasted);

  // 行編集
  const onRowEditEnded = () => {
    console.log("onRowEditEnded");
    // FIXME: これのせいで最上段編集でJSGジョブが上がってくる
    props.edit(cv.sourceCollection);
  };
  // FIXME
  if (grid.rowEditEnded.handlerCount === 2) {
    grid.rowEditEnded.removeHandler(grid.rowEditEnded._handlers[1].handler);
  }
  grid.rowEditEnded.addHandler(onRowEditEnded);

  // フィルタ変更
  const onFilterChanged = () => {
    console.log("onFilterChanged");
    filter.filterChanged.removeHandler(onFilterChanged);
    props.changeOrder(getOrder(cv));
    saveGridState(props, grid, filter);
  };
  filter.filterChanged.removeAllHandlers();
  filter.filterChanged.addHandler(onFilterChanged);

  // グルーピング変更
  const onGroupDescriptionsCollectionChanged = () => {
    console.log("onGroupDescriptionsCollectionChanged");
    props.changeOrder(getOrder(cv));
    saveGridState(props, grid, filter);
  };
  cv.groupDescriptions.collectionChanged.addHandler(
    onGroupDescriptionsCollectionChanged
  );

  // ソート変更
  const onSortDescriptionsCollectionChanged = () => {
    console.log("onSortDescriptionsCollectionChanged");
    props.changeOrder(getOrder(cv));
    saveGridState(props, grid, filter);
  };
  cv.sortDescriptions.collectionChanged.addHandler(
    onSortDescriptionsCollectionChanged
  );

  // 現在行変更
  const onCurrentChanged = (e: any) => {
    console.log("onCurrentChanged");
    if (e.currentItem) {
      const item = e.currentItem as Assign;
      props.changeCurrentRow(item.id, grid.selection.row);
    } else {
      const item = grid.collectionView.items[grid.selection.row - 2];
      props.changeCurrentRow(item?.id, grid.selection.row);
    }
  };
  cv.currentChanged.addHandler(onCurrentChanged);
};

/**
 * グリッドの状態を復元する
 * @param props
 * @param cv
 * @param filter
 */
const restoreGridState = (
  props: AssignListProps,
  cv: CollectionView,
  filter: any
) => {
  if (props.gridState) {
    // Stateに保存されている状態を元にグリッドの状態を復元
    cv.deferUpdate(() => {
      if (props.gridState) {
        // 列幅、順番
        // FIXME
        // grid.columnLayout = props.gridState.columns;
        // フィルタ
        filter.filterDefinition = props.gridState.filters;
      }
    });
  } else {
    // Stateに状態が保存されていない場合はデフォルト値を設定
    // FIXME
    // 列幅、順番
    // grid.columnLayout =
    //   '{"columns":[{"binding":"updatedAt","width":75,"header":"更新日","format":"MM/dd","isReadOnly":true},{"binding":"orderer","width":70,"header":"発注主","visible":false},{"binding":"client","width":70,"header":"客先"},{"binding":"process","width":80,"header":"工程"},{"binding":"skill","width":80,"header":"スキル"},{"binding":"inCharge","width":80,"header":"担当"},{"binding":"assign10","width":60,"header":"10月"},{"binding":"assign11","width":60,"header":"11月"},{"binding":"assign12","width":60,"header":"12月"},{"binding":"assign1","width":60,"header":"1月"},{"binding":"assign2","width":60,"header":"2月"},{"binding":"assign3","width":60,"header":"3月"},{"binding":"groupName","width":50,"header":"グループ","visible":false},{"binding":"jobNo","width":75,"header":"ジョブ番"},{"binding":"jobName","width":200,"header":"案件","visible":false},{"binding":"deliveryDate","width":55,"header":"納期"},{"binding":"probability","width":55,"header":"確度"},{"binding":"completed","width":45,"header":"完"},{"binding":"budget","width":60,"header":"引合"},{"binding":"memo","width":-1,"header":"メモ"}]}';
    // フィルタは何も設定しなければデフォルト値(フィルタ無し)に戻る
  }
};
